export default {
  'bandWidth.topTitle': '帶寬報告',
  'bandWidth.name': '帶寬',
  'bandWidth.topTitle.text': '（請按照 utc+8 的時區查看數據。）',
  'bandWidth.menu.text1': '邊緣位置',
  'bandWidth.menu.text2': '大洲',
  'bandWidth.menu.text3': 'CDN資源',
  'bandWidth.oneColumns.title2': '帶寬',
};
